import { bindActionCreators } from 'redux';
import { fetchAddressBookEntries } from '../../redux/addressBook/actions';
import { setCurrentPathName } from '../../redux/app/actions';

export default (dispatch) => ({
  ...bindActionCreators(
    {
      fetchAddressBookEntries,
      setCurrentPathName,
    },
    dispatch,
  ),
});
